import classNames from 'classnames';
import { FunctionComponent } from 'react';

import { useWeblab } from '@amzn/sustainability-central-shared-react';

import { ASX_REBRANDING } from 'src/constants';
import { THEME } from 'src/enums/theme';
import SearchIconRebranding from 'src/icons/search-rebranding.svg';
import SearchIconLegacy from 'src/icons/search.svg';

import styles from './SearchButtonLink.module.scss';

interface SearchButtonLinkProps {
  href: string;
  text: string;
  styleVariant?: 'primary' | 'secondary';
  theme?: THEME;
}

export const SearchButtonLink: FunctionComponent<SearchButtonLinkProps> = ({
  href,
  styleVariant = 'primary',
  text,
  theme = THEME.LIGHT,
}) => {
  const isSecondary = styleVariant === 'secondary';

  const asxRebrandingWeblab = useWeblab(ASX_REBRANDING);
  const isRebrandingApplied =
    asxRebrandingWeblab === 'T1' || theme === THEME.REBRAND_DARK || theme === THEME.REBRAND_LIGHT;

  const SearchIcon = isRebrandingApplied ? SearchIconRebranding : SearchIconLegacy;

  return (
    <a
      aria-label={text}
      className={classNames(styles.searchLink, styles[theme], { [styles.linkSecondary]: isSecondary })}
      href={href}
    >
      <SearchIcon
        className={classNames(styles.searchIcon, styles[theme], { [styles.iconSecondary]: isSecondary })}
        role="img"
      />
    </a>
  );
};
